export default {
  title: 'Histórico de edição do menu',
  subtitle: 'Veja quem alterou preços, disponibilidade e visibilidade em {{company}} — e quando.',
  filters: {
    type: {
      label: 'Tipo',
    },
    item: {
      placeholder: 'Todos os itens',
    },
    event: {
      label: 'Evento',
    },
  },
  columns: {
    when: 'Quando',
    who: 'Alterado por',
    type: 'Tipo',
    item: 'Item',
    event: 'Evento',
    changes: 'Alterações',
  },
  types: {
    product: 'Produto',
    modifier: 'Modificador',
  },
  events: {
    created: 'Criado',
    updated: 'Atualizado',
    deleted: 'Eliminado',
  },
  fields: {
    name: 'Nome',
    description: 'Descrição',
    price: 'Preço',
    is_available: 'Disponibilidade',
    is_visible: 'Visibilidade',
    is_available_for_pickup: 'Disponibilidade para recolha',
    is_available_for_delivery: 'Disponibilidade para entrega',
  },
  booleans: {
    on: 'Disponível',
    off: 'Indisponível',
  },
  pagination: {
    previous: 'Anterior',
    next: 'Seguinte',
  },
  causers: {
    orders_terminal: 'Terminal de pedidos',
  },
  system: 'Sistema',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Falha ao carregar o histórico de edição do menu',
  },
};
